"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var MenuWrapper = (0, material_1.styled)(material_1.AppBar)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.grey[600],
        boxShadow: 'none',
        maxHeight: theme.spacing(7),
        // flexGrow: 1,
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(MenuWrapper, {
    position: 'static',
    color: 'inherit',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    component: 'div',
});
